/* Free bnr: SP（<1000px）の横スクロールを初期表示で「真ん中のアイテム」が中央に来る位置に寄せる。
   PC はグリッド表示のため対象外。アイテムは固定幅なので画像読込前でも計算可。
   リサイズは「幅が変わった時だけ」再センタリング（モバイルのURLバー開閉=高さ変化は無視し、
   スクロール中の再センタリングによるガタつきを防ぐ）。 */
(() => {
  const PC_BP = 1000;

  const centerMiddle = (scroller) => {
    if (window.matchMedia(`(min-width: ${PC_BP}px)`).matches) return;
    const items = scroller.querySelectorAll('.c-free-bnr__item');
    if (items.length < 3) return;
    const mid = items[Math.floor(items.length / 2)];
    const scRect = scroller.getBoundingClientRect();
    const midRect = mid.getBoundingClientRect();
    const delta = (midRect.left + midRect.width / 2) - (scRect.left + scRect.width / 2);
    scroller.scrollLeft += delta;
  };

  const run = () => {
    requestAnimationFrame(() => {
      document.querySelectorAll('.c-free-bnr__scroller').forEach(centerMiddle);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  let lastWidth = window.innerWidth;
  let resizeTimer;
  window.addEventListener('resize', () => {
    if (window.innerWidth === lastWidth) return; // 高さのみの変化（URLバー等）は無視
    lastWidth = window.innerWidth;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(run, 150);
  });
})();
